import { Fragment } from 'react';

import useNTRegistrationApparel from './UseNTRegistrationApparel';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';

import NTRegistrationLeftNav from '../components/leftNav/NTRegistrationLeftNav';
import NTRegistrationLoadingModal from '../components/dialogs/NTRegistrationLoadingModal';
import ApparelFormGrid from '../../../components/grids/apparelForm/ApparelFormGrid';

import style from '../NTRegistration.module.css';

const NTRegistrationApparel = () => {
  const {
    isLoading,
    personId,
    gridData,
    competitionGenderTypeCode,
    onSubmitApparelForm,
    onContinueClicked,
    onBackClicked,
    onNTRegistrationError,
    updatePageHasUnsavedChanges
  } = useNTRegistrationApparel();

  return (
    <Fragment>
      <NTRegistrationLeftNav viewTitle={'Apparel'}>
        {isLoading === false &&
          <ApparelFormGrid
            gridData={gridData}
            personId={personId}
            competitionGenderTypeCode={competitionGenderTypeCode}
            onSubmitFormCallback={onSubmitApparelForm}
            onIsDirtyChanged={updatePageHasUnsavedChanges}
            onErrorCaught={onNTRegistrationError} />
        }
        <div className={['row', style.PageNavigationButtons].join(' ')}>
          <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
            <SecondaryButton type="button" onClick={onBackClicked}>Back</SecondaryButton>&nbsp;
            <PrimaryButton type="button" onClick={onContinueClicked}>Continue</PrimaryButton>
          </div>
        </div>
        <NTRegistrationLoadingModal isLoading={isLoading} />
      </NTRegistrationLeftNav>
    </Fragment>
  );
};

export default NTRegistrationApparel;